import React, { FunctionComponent } from 'react';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/components/vatClauseStyles';
import VatIcon from 'assets/img/icon_vat_grey.svg';
import { BodyS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';

const useStyles = makeStyles(styles);

interface IVatClause {
	type?: 'wrapped' | 'one-line';
}

const VatClause: FunctionComponent<IVatClause> = ({ type = 'wrapped' }) => {
	const classes = useStyles();

	return (
		<div className={classes.wrapper}>
			<div className={classes.iconContainer}>
				<img alt="vat icon" src={VatIcon} />
			</div>
			<BodyS useNewLine color={'disabled-light'}>
				{translate(`vat-clause.description.${type}`)}
			</BodyS>
		</div>
	);
};

export default VatClause;
